

export default {

    data() {
        return {
            
        };
    },

    mounted: function (){
    },

    methods:{
        nav_offcial(){
            let HOST = process.env.HOST;
            if (HOST === 'prod') {
                window.open('https://u8d.umsin.com');
            } else {
                // window.open('http://u8d.umsin.com:8085');
                window.open('https://u8d.umsin.com');
            }
        }
    },

}


// WEBPACK FOOTER //
// ./src/components/header/header.js